import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';

import { rootReducer } from './rootReducer';
import { watchAll } from './rootSaga';

const sagaMiddleware = createSagaMiddleware();

const logger =
	({ getState }: any) =>
	(next: any) =>
	(action: any) => {
		const updatedAction = {
			...action,
			auth: getState().auth,
			user: getState().user,
		};
		const returnValue = next(updatedAction);
		return returnValue;
	};

const composeEnhancers = compose;

const configureStore = () => {
	const store = createStore(
		rootReducer,
		composeEnhancers(applyMiddleware(logger, sagaMiddleware))
	);
	sagaMiddleware.run(watchAll);
	return store;
};

export const store = configureStore();
